import React from "react";
import BlueSummaryItem from "../../atoms/BlueSummaryItem";
// import i18n from "i18n";
import styles from "./MainApp.organisms.BlueSummary.module.scss";


export const BlueSummary = ({items}) => {
    return(
        <div className={styles["blue-summary-container"]}>
            {items.map( item => {
                return(
                    <BlueSummaryItem icon={item.icon} number={item.number} label={item.label} key={item.label} />
                )
            })}
        </div>
    )
}

export default BlueSummary;